<div class="mb-3">
  <div class="flex-shrink-0 p-3 bg-white" style="width: 280px">
    <ul class="list-unstyled ps-0">
      <li class="mb-1">
        <h6 class="fw-semibold px-2 mb-2" i18n>Mein Konto</h6>
        <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
          <app-my-account-nav variant="sidebar"></app-my-account-nav>
        </ul>
      </li>
    </ul>
  </div>
</div>
